<script setup lang="ts">
import EditPostDrawer from '@/pages/erp/du/org/view/du-position-drawer.vue'
import type { PostProperties } from '@/pages/erp/du/org/db/du-position-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DUPOSITION',
    },
})

const compId = ref(useStorage('compNo', 'nstc').value)
const orgType = ref('C')
const postNo = ref()
const postName = ref()
// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '職稱代號', key: 'postNo' },
    { title: '職稱', key: 'postName' },
    { title: '使用狀態', key: 'status' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: postsData, execute: fetchPosts } = await useApi<any>(createUrl('/du/org/position/searchPost', {
  query: {
    compId,
    orgType,
    postNo,
    postName,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): PostProperties[] => postsData.value.data.postPage.content)
const totalDatas = computed(() => postsData.value.data.postPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (postData: PostProperties) => {
  voData = {
    ...postData,
    compId: toCode(postData.compId),
    orgType: toCode(postData.orgType),
    postNo: toCode(postData.postNo)
  }
  console.log('editPost: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (postData: PostProperties) => {
    voData = {
      ...postData,
      compId: toCode(postData.compId),
      orgType: toCode(postData.orgType),
      postNo: toCode(postData.postNo)
    }
    console.log('copyPost: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (postData: PostProperties) => {
  await $api('/du/org/position/createPost', {
    method: 'POST',
    body: { post: postData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchPosts()
}

const updateData = async (postData: PostProperties) => {
  await $api('/du/org/position/updatePost', {
    method: 'PUT',
    body: { post: postData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchPosts()
}

  // 👉 Delete data
const deleteData = async (postData: PostProperties) => {
  const compId = toCode(postData.compId)
  const orgType = toCode(postData.orgType)
  const postNo = toCode(postData.postNo)
    $swal({
    title: `確定要刪除 ${postData.postName} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消"
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/du/org/position/deletePost`, {
        method: 'DELETE',
        query: {
          compId,orgType,postNo
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchPosts()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

const statusText = (status) => {
  if (status == 'OP' || status == 'A') {
    return '使用中'
  }
  if (status == 'CA' || status == 'X') {
    return '作廢'
  }
  return status
}


</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="postNo"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入職稱代號"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="postName"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入職稱"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增職稱基本資料
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.orgType="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.orgType }}
          </div>
      </template>

      <template #item.postNo="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ toCode(item.postNo) }}
          </div>
      </template>

      <template #item.postName="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.postName }}
          </div>
      </template>

      <template #item.status="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ statusText(item.status) }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditPostDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :post-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
